if(!customElements.get('social-videos')) {
  class SocialModal extends HTMLElement {
    constructor() {
      super()

      this.activeIndex = 0;

      this.elVideos = this.querySelectorAll('video-component');
      this.elCarousel = this.querySelector('[data-social-modal-carousel]');
      this.elModal = this.closest('popup-modal');

      this.swiper = this.elCarousel.swiper; 

      this.swiper.on('realIndexChange', ({ realIndex }) => {
        if(this.elModal.open) {
          this.setActiveVideo(realIndex);
        }
      })

      this.elModal.addEventListener('toggle', this.onModalChange.bind(this));
    }

    setActiveVideo(activeIndex) {
      this.activeIndex = activeIndex;
      this.elVideos.forEach((el, index) => {
        if(index == activeIndex) {
          !el.loaded && el.lazyLoadVideo();
          setTimeout(() => {
            el.playVideo();
            el.muted = false;
            el.querySelector('video').addEventListener('ended', () => {
              const newIndex = index + 1 == this.elVideos.length ? 0 : index + 1;
              this.swiper.slideToLoop(newIndex);
            });
          }, 100);
        } else {
          el.pauseVideo(true);
          el.muted = true;
          el.setAttribute('data-audio', false);
        }
      })
    }

    onModalChange({ detail }) {
      const { open, el: elToggle } = detail;
      const { swiper } = this.elCarousel;
      const activeVideoIndex = elToggle.getAttribute('data-social-video');

      if(open) {
        swiper.slideToLoop(activeVideoIndex, 1)
      } else {
        const elActiveVideo = this.elVideos[this.activeIndex]
        elActiveVideo.pauseVideo(true);
        elActiveVideo.toggleAudio(false);
      }
    }
  }

  customElements.define('social-modal', SocialModal);
}